import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

class Company {
    constructor () {
        this.name = ''
        this.aliases = []
        this.registrationNumber = ''
        this.registrationCountry = ''
        this.employees = 0
        this.industries = []
        this.countries = []
    }
}

class Progress {
    constructor (admin, isGdpr) {

        if (isGdpr) {
            if (admin)
                this.steps = [
                    {name: 'account', path: '/', done: false},
                    {name: 'names', path: '/names', done: false, subSteps: 4},
                    {name: 'gdpr-invites', path: '/gdpr-invites', done: false},
                    {name: 'download', path: '/download', done: false}
                ]
            else
                this.steps = [
                    {name: 'account', path: '/', done: false},
                    {name: 'download', path: '/download', done: false}
                ]
        } else {
            if (admin)
                this.steps = [
                    {name: 'account', path: '/', done: false},
                    {name: 'groups', path: '/groups', done: false},
                    {name: 'team', path: '/team', done: false},
                    {name: 'download', path: '/download', done: false}
                ]
            else
                this.steps = [
                    {name: 'account', path: '/', done: false},
                    {name: 'download', path: '/download', done: false}
                ]
        }
        this.currentStepIndex = 0
        this.subStep = 0
        this.currentStepName = 'account'
        this.value = (this.currentStepIndex + 1) / this.steps.length
    }
    next () {
        this._doStep(true)
    }
    back () {
        this._doStep(false)
    }
    _doStep(forward) { // otherwise is backward
        this.subStep = 0
        const router = require('./router').default
        const currentStep = this.steps[this.currentStepIndex]

        if (forward) {
            currentStep.done = true
        }
        // update progress
        this.currentStepIndex = forward ? this.currentStepIndex + 1 : this.currentStepIndex - 1
        this.value = (this.currentStepIndex + 1) / this.steps.length
        const nextStep = this.steps[this.currentStepIndex]

        if (!forward) {
            nextStep.done = false
            if (nextStep.subSteps) {
                this.subStep = nextStep.subSteps - 1
            }
        }

        router.push(nextStep.path)
    }
}
class PageInfo {
    constructor () {
        this.title = ''
        this.titleTooltip = ''
        this.error = ''
        this.loading = false
    }
}
class Account {
    constructor () {
        this.name = ''
        this.password = ''
        this.confirmPassword = ''
        this.email = ''
        this.role = ''

        this.inviteKey = ''
        this.dailyTasks = []
        this.otherDailyTask = ''
        this.isAdmin = false
        this.isGDPR = false
    }
}

class RegisterInfo {
    constructor() {
        this.email = ''
        this.userExistsError = false
        this.success = false
        this.submitted = false
    }
}

class GDPRNames {
    constructor () {
        this.currentEmployees = []
        this.formerEmployees = []
        this.currentCustomers = []
        this.formerCustomers = []
    }
}

const state = {
    pageInfo: new PageInfo(),
    account: new Account(),
    company: new Company(),
    progress: new Progress(),
    gdprNames: new GDPRNames(),
    registerInfo: new RegisterInfo(),
    groups: [],
    categories: [],
    currentUser: {}
}

const mutations = {
    // go to the next page
    next (state) {
        state.progress.next()
    },
    back (state) {
        state.progress.back()
    },
    updateSubStep (state, step) {
        state.progress.subStep = step
    },
    updateInviteInfo(state, changes) {
        state.account.email = changes['email']
        state.account.isAdmin = changes['firstUser']
        state.account.isGDPR = changes['isGdpr']
        state.progress = new Progress(state.account.isAdmin, state.account.isGDPR)
    },
    updateRegisterInfo(state, changes) {
        Object.assign(state.registerInfo, changes)
    },

    updateAccount(state, changes) {
        Object.assign(state.account, changes)
    },
    updateCompany(state, changes) {
        Object.assign(state.company, changes)
    },
    updatePageInfo(state, changes) {
        Object.assign(state.pageInfo, changes)
    },
    createGroup(state, group) {
        state.groups.push(group)
    },
    updateGroup(state, group) {
        const index = state.groups.findIndex(g => g.id == group.id)
        if (index === -1) {
            console.error(`Group "${group.id}" doesn't exist. Update failed.`)
        }
        state.groups[index] = group
    },
    getAllGroups(state, allGroups) {
        state.groups = allGroups
    },
    getAllCategories(state, allCategories) {
        state.categories = allCategories
    },
    setCurrentUser(state, user) {
        state.currentUser = user
    }
}

function handleErrorsWrapper(actions) {

    const wrappedActions = {}

    function wrapper (action) {

        return function wrappedAction({commit, dispatch}) {

            return action(...arguments).catch(err => {
                if (!/2../.test(err.response.status)) {
                    dispatch('error', 'Something went wrong :( Try again later.')
                }
                throw err
            })
        }
    }

    for (var actionName in actions) {
        wrappedActions[actionName] = wrapper(actions[actionName])
    }

    return wrappedActions
}

var actions = {
    getInviteInfo ({commit, state}, key) {
            
            commit('updatePageInfo', {loading: true});
            return Vue.$Api.getInviteInfo(key).then((res) => {
                commit('updateInviteInfo', res)
                commit('updateAccount', {inviteKey: key});
                commit('updatePageInfo', {loading: false});
            }).catch((err) => {
                commit('updatePageInfo', {
                    error: 'Reason: Invitation key has expired.',
                    loading: false
                });
                commit('updateAccount', {inviteKey: ""});
                window.location.href = '/#/download-direct?exists=true'
            });
    },
    createUser ({commit, state}, user) {
        return Vue.$Api.createUser({
            name: user.name,
            email: user.email,
            inviteKey: state.account.inviteKey,
            position: user.role,
            dailyTasks: user.dailyTasks,
            otherDailyTask: user.otherDailyTask,
            emailCheck: user.email,
            password: user.password,
            passwordCheck: user.confirmPassword,
        }).then((res) => {
            commit('setCurrentUser', res)
            Vue.$Api.setAuth(res.token)
        })
    },
    createCompany ({commit}, company) {
        return Vue.$Api.admin.createCompany({
            companyNames: company.names,
            companyRegNumber: company.registrationNumber,
            countryRegistration: company.registrationCountry,
            numEmployees: company.employees,
            industry: company.industries,
            countriesOperation: company.countries
        })
    },
    createGroup ({commit}, {users, categories, name}) {
        return Vue.$Api.admin.group.createGroup({
            name,
            categories,
            users
        }).then(response => commit('createGroup', response))
    },
    updateGroup ({commit}, {id, users, categories, name}) {
        return Vue.$Api.admin.group.updateGroup({
            id,
            name,
            categories,
            users
        }).then(response => commit('updateGroup', response))
    },

    getAllGroups ({commit}) {
        return Vue.$Api.admin.group.index().then(response => commit('getAllGroups', response))
    },

    getAllCategories ({commit}) {
        return Vue.$Api.category.index().then(response => commit('getAllCategories', response))
    },

    updateGDPRNames ({commit}, {currentEmployees, formerEmployees, currentCustomers, formerCustomers}) {
        return Vue.$Api.admin.updateGDPRNames({
            currentEmployees: currentEmployees,
            formerEmployees: formerEmployees,
            currentCustomers: currentCustomers,
            formerCustomers: formerCustomers
        })
    },

    error ({commit}, options) {
        const DEFAULT_DELAY_SECONDS = 5

        const message = typeof options === 'string' ? options : options.message
        const delay = options.delay ? options.delay : DEFAULT_DELAY_SECONDS

        commit('updatePageInfo', {
            error: message
        })

        setTimeout(() => { commit('updatePageInfo', {error: ''}) }, delay * 1000)
    }
}

const getters = {
    isGDPRAdmin: state => {
        return state.account.isAdmin && state.account.isGDPR
    }
}

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations
})



// WEBPACK FOOTER //
// ./apps/account/store.js